var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":require("../assets/images/weihu.png"),"alt":""}}),_c('p',[_vm._v("商品维护中，稍后再试试吧~")])])}]

export { render, staticRenderFns }